import { ApiResponse } from './ApiResponseTypes'

interface ErrorResponseDetailItem {
  status?: string
  source?: { pointer: string }
  title?: string
  detail?: string
}

type ErrorResponseDetail = string | ErrorResponseDetailItem[]

interface ErrorResponseData {
  code?: number
  id?: string
  service?: string
  detail?: ErrorResponseDetail
}
interface ErrorResponse extends ApiResponse<ErrorResponseData> {
  error: ErrorResponseData | string
  errorCode?: number
}

const isErrorResponse = (e: ApiResponse<any>): e is ErrorResponse => {
  return e !== undefined && typeof e === 'object' && e !== null && 'error' in e
}

const isErrorResponseData = (e: any): e is ErrorResponseData => {
  return typeof e === 'object' && e !== null && ('code' in e || 'detail' in e)
}

const isErrorResponseDetailItem = (e: any): e is ErrorResponseDetailItem => {
  return typeof e === 'object' && e !== null && ('status' in e || 'source' in e || 'title' in e || 'detail' in e)
}

export { isErrorResponse, isErrorResponseData, isErrorResponseDetailItem }
export type { ErrorResponse, ErrorResponseData, ErrorResponseDetail, ErrorResponseDetailItem }
